import { connect } from 'react-redux';

import { downloadCSVTemplate } from '../../../../../state/modules/imports/actions';
import DownloadCSVButton from '../components/DownloadCSVButton';

const mapStateToProps = (state, ownProps) => {
  return {
    isCSVDownloading: state.imports.get('isCSVDownloading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    downloadTemplate: (cb) => {
      dispatch(downloadCSVTemplate(cb));
    },
  };
};

const DownloadCSVButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadCSVButton);

export default DownloadCSVButtonContainer;
